/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type HumanitySearchHandlerInfo = {
    ID: HumanitySearchHandlerInfo.ID;
    SRLIST: Record<string, any>;
};

export namespace HumanitySearchHandlerInfo {

    export enum ID {
        BLOCK = 'BLOCK',
        TRANSACTION = 'TRANSACTION',
        ADDRESS = 'ADDRESS',
        ADDRESS_LABEL = 'ADDRESS_LABEL',
        BATCH_TRX = 'BATCH_TRX',
        TOKEN = 'TOKEN',
    }


}

